import type { Contact } from "@/features/contact/types";

/** Echo is waiting on a person: a question for a teammate, a draft or action
 *  to approve, or a handover. Mirrors the backend's `NEEDS_YOU_EXPRESSION`. */
export const needsYou = (
  contact: Pick<Contact, "aiPending" | "humanAgentRequired">,
): boolean => contact.aiPending != null || contact.humanAgentRequired === true;
